import React from 'react';
import '../../App.css';
import Footer from '../Footer';
import MainSection from '../MainSection';


function Home() {
  return(
    <>
      <MainSection/>
      <Footer/>
    </>
  )
}

export default Home;